export const getCountStats = (state) => state.countStats
export const getAdvancedCountStats = (state) => state.advancedCountStats
export const getDataStats = (state) => state.dataStats
export const getCategoryStats = (state) => state.categoryStats
export const getCustomerStats = (state) => state.customerStats
export const getSaleStats = (state) => state.saleStats
export const getBestDayStats = (state) => state.bestDayStats
export const isLoading = (state) => state.loading
